import { API_URL, API_URL_SSR } from "../config"; // project configuration file
import fetch from "isomorphic-unfetch";
import store from "../store"; // Access redux store data
import { setAlert, toggleLoader } from "../store/actions";
import { Router } from "../routes";
import { clear_client_storage, get_cookie } from "utils";
/*******************
 @purpose : Convert Responce to JSON
 @Parameter : {response, status}
 @Author : INIC
 ******************/
const makeJson = async (response, status) => {
    const json = await response.json();
    return Promise.resolve({ ...json, statusCode: status });
};
/*******************
 @purpose : API Responce Handler
 @Parameter : {alert, res}
 @Author : INIC
 ******************/
const responseHandler = (alert) => (response) => {
    const contentType = response?.headers?.get("content-type");

    if (contentType && contentType?.indexOf("application/json") !== -1) {
        const promise = makeJson(response, response.status);
        if (typeof window === "undefined") return promise;
        const ok = response.success;
        promise
            .then((res) => {
                store.dispatch(toggleLoader("content_loader", false));
                if (res.statusCode == 401) {
                    let token = store?.getState()?.user?.token;
                    if (token) {
                        clear_client_storage();
                        window.location.replace("/");
                    }
                }
                if (res.statusCode == 503) {
                    Router.push("/maintenance");
                }
                if (alert) {
                    if (res.message) {
                        //set alert here if alert is choosen
                        store.dispatch(setAlert(res.message, ok ? "success" : "error"));
                    }
                }
            })
            .catch(() => {
                store.dispatch(toggleLoader("button_loader", false));
                store.dispatch(toggleLoader("content_loader", false));
            });
        return promise;
    }
};

/*******************
 @purpose : API Request Header Types
 @Parameter : {}
 @Author : INIC
 ******************/
const getHeader = () => ({
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${store?.getState()?.user?.token}`,
});

/*******************
 @purpose : API Request Header Types
 @Parameter : {}
 @Author : INIC
 ******************/
const getHeaderForSSR = (token) => {
    let headers = "";
    if (token) {
        headers = {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        };
    } else {
        headers = {
            Accept: "application/json",
        };
    }
    return headers;
};

/*******************
 @purpose : API Request Header Types
 @Parameter : {}
 @Author : INIC
 ******************/
const headerForGet = () => ({
    Accept: "application/json",
});

const getApiURL = () => {
    if (typeof window !== 'undefined') {
        return API_URL;
    } else {
        return API_URL_SSR;
    }
}

/*******************
 @purpose : Fetch Get API
 @Parameter : {data}
 @Author : INIC
 ******************/
export const get = (...data) => {
    const [url, alert = false, loader = true] = data;

    if (url != "profile") {
        if (loader) store?.dispatch(toggleLoader("content_loader", true));
    }

    return fetch(`${getApiURL()}/${url}`, {
        method: "get",
        headers: getHeader(),
    })
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};

/*******************
 @purpose : Fetch Get API
 @Parameter : {data}
 @Author : INIC
 ******************/
export const getForSSR = (...data) => {
    const [url, alert = false, loader = true, token = ""] = data;

    return fetch(`${getApiURL()}/${url}`, {
        method: "get",
        headers: getHeaderForSSR(token),
    })
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};

/*******************
 @purpose : Fetch Get API using full url
 @Parameter : {data}
 @Author : INIC
 ******************/
export const getForWithoutHeader = (...data) => {
    const [url, alert = false, loader = true] = data;

    if (loader) store?.dispatch(toggleLoader("content_loader", true));

    return fetch(`${getApiURL()}/${url}`, {
        method: "get",
        headers: headerForGet(),
    })
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};

/*******************
 @purpose : Fetch Get API using full url
 @Parameter : {data}
 @Author : INIC
 ******************/
export const getForUrl = (...data) => {
    const [url, alert = false, loader = true] = data;
    if (loader) store?.dispatch(toggleLoader("content_loader", true));
    return fetch(`${url}`, {
        method: "get",
        headers: get_cookie("token")
            ? getHeaderForSSR(get_cookie("token"))
            : headerForGet(),
    })
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};

/*******************
 @purpose : Fetch Get API using full url
 @Parameter : {data}
 @Author : INIC
 ******************/
export const getForUrlWithAuth = (...data) => {
    const [url, alert = false, loader = true] = data;
    if (loader) store?.dispatch(toggleLoader("content_loader", true));
    return fetch(`${url}`, {
        method: "get",
        headers: getHeader(),
    })
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};

/*******************
 @purpose : Fetch Post API
 @Parameter : {data}
 @Author : INIC
 ******************/
export const post = (...data) => {
    const [url, alert = true, body, loader = true, buttonLoader = false] = data;

    if (loader) store?.dispatch(toggleLoader("content_loader", true));
    if(buttonLoader) store?.dispatch(toggleLoader("button_loader", true));
    return fetch(`${getApiURL()}/${url}`, {
        method: "POST",
        headers: getHeader(),
        body: JSON.stringify(body),
    })
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};
/*******************
 @purpose : Fetch Put API
 @Parameter : {data}
 @Author : INIC
 ******************/
export const put = (...data) => {
    const [url, alert = false, body] = data;
    return fetch(`${getApiURL()}/${url}`, {
        method: "put",
        headers: getHeader(),
        body: JSON.stringify(body),
    })
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};
/*******************
 @purpose : Fetch Delete API
 @Parameter : {data}
 @Author : INIC
 ******************/
export const remove = (...data) => {
    const [url, alert = false] = data;
    return fetch(`${getApiURL()}/${url}`, {
        method: "delete",
        headers: getHeader(),
    })
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};
/*******************
 @purpose : Fetch Patch API
 @Parameter : {data}
 @Author : INIC
 ******************/
export const patch = (...data) => {
    const [url, alert = false, body] = data;
    return fetch(`${getApiURL()}/${url}`, {
        method: "patch",
        headers: getHeader(),
        body: JSON.stringify(body),
    })
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};
/*******************
 @purpose : Fetch Post API
 @Parameter : {data}
 @Author : INIC
 ******************/
export const file = (...data) => {
    const [url, alert = false, body, loader = true] = data;
    if (loader) store?.dispatch(toggleLoader("content_loader", true));
    return fetch(`${getApiURL()}/${url}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${store?.getState()?.user?.token}`,
            Accept: "application/json",
        },
        body: body,
    })
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};

/*******************
 @purpose : googleAuthHandler
 @Parameter : {data}
 @Author : INIC
 ******************/
export const googleAuthHandler = async (access_token) => {
    const getHeader = () => ({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${access_token}`,
    });

    var requestOptions = {
        method: "GET",
        headers: getHeader(),
        redirect: "follow",
    };

    return await fetch(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        requestOptions
    )
        .then(responseHandler(alert))
        .catch(responseHandler(alert));
};

/*******************
 @purpose : googleDistanceMatrix
 @Parameter : {originAddress,destinationAddress}
 @Author : INIC
 ******************/
export const googleDistanceMatrix = async (origin, destination) => {
    const apiUrl = `https://maps.googleapis.com/maps/api/distancematrix/json?destinations=${destination}&origins=${origin}&units=imperial&key=AIzaSyDEwgh0lcJI8bG39KApw7Sv_hwRNJyx3Po`;

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    };

    const response = await fetch(apiUrl, requestOptions);

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
};